import { object, string } from 'yup';
import { trpcNoAuth } from '@prishapolicy/shared/trpc';
import { Button, Form, TextInput, useWindowLocation } from '@prishapolicy/shared/ui';
import dynamic from 'next/dynamic';

const validation = object().shape({
  name: string().required(),
  phone: string().required(),
});

const DynamicSocials = dynamic(() => import('./socials'), {
  ssr: false,
});
export const CallbackForm = () => {
  const currentPageUrl = useWindowLocation();
  const mutation = trpcNoAuth['lead-management']['call-back-request']['raise'].useMutation();
  return (
    <div className="bg-white py-5">
      <p className="mb-2 flex flex-wrap font-bold">Need More Info? Get on a call with us.</p>
      <Form
        validationSchema={validation}
        initialValues={{
          name: '',
          phone: '',
        }}
        onSubmit={async (values) => {
          await mutation.mutateAsync({ ...values, lead_sourceUrl: currentPageUrl });
        }}
      >
        <div className="flex flex-col gap-2">
          <TextInput name="name" placeholder="Enter your Name" />
          <TextInput name="phone" placeholder="Phone Number" />
          <Button type="submit" text="Call me back!" size="large" />
          <div className="bg-grey-100 mt-2 h-[2px]"></div>
          <div className="-mt-2">
            <DynamicSocials />
          </div>
        </div>
      </Form>
    </div>
  );
};
